import { render, staticRenderFns } from "./doc_content.vue?vue&type=template&id=07a31a6a&scoped=true"
import script from "./doc_content.vue?vue&type=script&lang=js"
export * from "./doc_content.vue?vue&type=script&lang=js"
import style0 from "./doc_content.vue?vue&type=style&index=0&id=07a31a6a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a31a6a",
  null
  
)

export default component.exports